module.exports = __webpack_public_path__ + "img/LS.119ce0b6.png";